<template>
  <div v-if="isVisible" class="c-dashboard__message" role="alert">
    {{ message }}
    <button
      class="c-dashboard__message__close"
      @click="hideMessage"
      aria-label="close"
    ></button>
  </div>
</template>

<script>
export default {
  name: "DashboardAlert",

  props: {
    message: {
      type: String,
      required: true,
      default: "",
    },
  },

  data() {
    return {
      isVisible: false,
    };
  },

  mounted() {
    this.checkMessageVisibility();
  },

  methods: {
    hideMessage() {
      this.isVisible = false;
      localStorage.setItem("dashboardMessageClosed", "true");
      this.$emit("close");
    },

    checkMessageVisibility() {
      const isMessageClosed =
        localStorage.getItem("dashboardMessageClosed") === "true";
      this.isVisible = !isMessageClosed;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/components/wbwb/wbwb-dashboard-alert.vue